<template>
    <!-- Participant -->
    <div>
        <!--Individual CStrip-->
        <div class="row no-gutters">
            <div
                class="col-md-12 channelStrip p-1"
                :class="{ channelStripRecord: isRecording }"
            >
                <!--Channel Strip inner elements-->

                <!--Name Row-->
                <div
                    class="row name no-gutters justify-content-between pl-1 pt-1"
                >
                    <div class="col-auto">
                        {{ displayName }}
                    </div>
                </div>
                <!--/Name Row-->

                <div v-if="$store.getters['auth/isHost'] && browserType == 'Safari'">
                    <div class="small alert alert-danger">
                        Using Safari browser - use with caution - check recording
                    </div>
                </div>

                <div v-if="peerError" class="row name no-gutters justify-content-between pl-1 pt-1">
                    <div class="small alert alert-danger">
                        {{peerError}}
                    </div>
                </div>

                <div v-if="hasVideo" class="row no-gutter">
                    <div class="col-12 pl-3 pt-1">
                        <video
                            playinline
                            autoplay
                            :src-object.prop.camel="mediaSource"
                            :muted.prop="isMuted"
                            style="width: 384px; height: 216px"
                        />
                    </div>
                </div>

                <!--Mute/PPM/Mic-Cut Glyph Row-->
                <div class="row no-gutters">
                    <!--PPM-->
                    <div class="col-12 col-lg-7 p-1" style="height: 50px">
                        <AudioMeter
                            :audioContext="audioContext"
                            :mediaStream="mediaSource"
                        />
                    </div>

                    <!--mute-->
                    <div class="col-8 col-lg-3 muteBtnCol p-1">
                        <ToggleButton 
                            v-if="$store.getters['auth/isHost']"
                            :value="isMicCut"
                            textOn="Un-cut Mic"
                            textOff="Cut Mic"
                            @toggle="$emit('toggleRemoteMicCut')"
                        />
                    </div>

                    <!-- Mic Cut Glyph Column-->
                    <div class="col-3 col-lg-1 p-1 text-center micCutCol">
                        <img
                            v-if="isMicCut"
                            src="@/assets/images/micCut.svg"
                            style="height: 38px"
                            class="img-fluid micCutIcon"
                            alt="Mic Muted"
                        />
                    </div>
                </div>

                <div class="row no-gutters name">
                    <div class="col-5">
                        <span style="font-size: x-small">{{
                            audioDeviceLabel
                        }}</span>
                    </div>

                    <div class="col-5">
                        <span v-if="hasVideo" style="font-size: x-small">{{
                            videoDeviceLabel
                        }}</span>

                        <b-button v-if="isAdmin" @click="toggleMute()">{{ data.playerMuted ? 'unmute' : 'mute'}}</b-button>
                    </div>

                    <div class="col-1 p-1">
                        <b-button
                            v-b-toggle="`status-${peerId}`"
                            style="
                                font-size: x-small;
                                border: none;
                                background-color: transparent;
                                color: black;
                            "
                        >
                            <b-icon-chevron-bar-expand class="when-closed" />
                            <b-icon-chevron-bar-contract class="when-opened" />
                        </b-button>
                    </div>
                </div>

                <b-collapse :id="'status-' + peerId">
                    <div class="row no-gutters text-dark">
                        <table style="font-size: x-small">
                            <tr>
                                <th>bitrate</th>
                                <td>{{ data.stats.bitrate }}kbps</td>
                            </tr>
                            <tr>
                                <th>jitter</th>
                                <td>{{ data.stats.jitter }}ms</td>
                            </tr>
                            <tr>
                                <th>packet loss</th>
                                <td>{{ data.stats.packetLoss }}%</td>
                            </tr>
                        </table>
                    </div>

                    <b-button 
                        variant="warning" 
                        v-if="$store.getters['auth/isHost']"
                        @click="$emit('drop')"
                    >
                        remove from session
                    </b-button>
                </b-collapse>
            </div>
        </div>

        <audio
            ref="audioElement"
            v-if="mediaSource"
            :src-object.prop.camel="mediaSource"
            :muted.prop="isMuted"
            autoplay
            controls
            hidden
        />
    </div>
    <!-- /Participant -->
</template>

<style scoped>
    .channelStrip {
        background-color: #ebebeb;
        border-radius: 10px;
        border-width: 5px;
        border-color: black;
        border-style: solid;
    }

    .channelStripRecord {
        border-color: red;
    }

    .name {
        color: black;
    }

    .collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
        display: none;
    }
</style>

<script>
import ParticipantLogic from "./ParticipantLogic";
import AudioMeter from "./PeakDisplay";
import ToggleButton from "./ToggleButton";
import {
    BIconChevronBarExpand,
    BIconChevronBarContract,
} from "bootstrap-vue";

export default {
    name: "ParticipantRemote",
    extends: ParticipantLogic,
    components: {
        AudioMeter,
        ToggleButton,
        BIconChevronBarExpand,
        BIconChevronBarContract,
    },
    computed: {
        isAdmin() {
            return this.$store.getters['auth/isAdmin'];
        }
    }
};
</script>